import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

// This is a guard that will load the translation files before the app loads
export const TranslationLoaderGuard: CanActivateFn = () => {
  const translateService = inject(TranslateService);

  // When implementing language switcher, this should be where we load the language
  return new Observable((observer) => {
    translateService.getTranslation('en').subscribe({
      next: () => {
        observer.next(true);
        observer.complete();
      },
      error: (error) => {
        observer.next(false);
        observer.error(error);
      },
    });
  });
};
